// @ts-nocheck
import { HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    UpdatePrice,
} from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/UpdatePriceBreakPrice";
import { getPriceBreaksForCurrentQuoteLine } from "@insite/client-framework/Store/Pages/RfqQuoteDetails/RfqQuoteDetailsSelectors";
import { BreakPriceRfqModel } from "@insite/client-framework/Types/ApiModels";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = HandlerWithResult<
    {
        index: number;
        price: number;
        // Store Custom Code
        calculationMethod?: string;
        percent?: number;
    },
    { updatedPriceBreaks: BreakPriceRfqModel[] }
>;

export const StoreUpdatePrice: HandlerType = props => {
    const priceBreaks = getPriceBreaksForCurrentQuoteLine(props.getState());
    if (!priceBreaks) {
        return false;
    }

    const { index, price, calculationMethod, percent } = props.parameter; // Store Custom Code
    const updatedPriceBreaks = priceBreaks.slice();

    updatedPriceBreaks[index] = {
        ...updatedPriceBreaks[index],
        price,
        // Store Custom Code
        calculationMethod: calculationMethod || "",
        percent: percent || null,
    };

    props.result = { updatedPriceBreaks };
};

replaceInChain(chain, UpdatePrice, StoreUpdatePrice);
